var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPingprobeLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8573 40.0269C13.7653 38.3783 10.3745 35.3572 8.26655 31.4818C6.15862 27.6064 5.46497 23.1182 6.30459 18.7872C7.14421 14.4563 9.46477 10.5524 12.8682 7.74546C16.2716 4.93848 20.5457 3.40332 24.9573 3.40332C29.369 3.40332 33.6431 4.93848 37.0465 7.74546C40.4499 10.5524 42.7704 14.4563 43.6101 18.7872C44.4497 23.1182 43.756 27.6064 41.6481 31.4818C39.5402 35.3572 36.1494 38.3783 32.0573 40.0269",
    stroke: "#0053A0",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4773 30.9665C34.2141 29.4349 35.4433 27.4107 36.0014 25.1634C36.5594 22.916 36.4198 20.5519 35.6011 18.3858C34.7825 16.2198 33.3236 14.3543 31.4187 13.0378C29.5137 11.7213 27.253 11.0161 24.9373 11.0161C22.6217 11.0161 20.361 11.7213 18.456 13.0378C16.551 14.3543 15.0922 16.2198 14.2735 18.3858C13.4549 20.5519 13.3153 22.916 13.8733 25.1634C14.4313 27.4107 15.6605 29.4349 17.3973 30.9665",
    stroke: "#0053A0",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9372 24.3065C27.0359 24.3065 28.7372 22.6052 28.7372 20.5065C28.7372 18.4079 27.0359 16.7065 24.9372 16.7065C22.8386 16.7065 21.1372 18.4079 21.1372 20.5065C21.1372 22.6052 22.8386 24.3065 24.9372 24.3065Z",
    stroke: "#0053A0",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7372 31.9064C28.7372 34.0064 28.7372 45.2064 24.9372 45.2064C21.1372 45.2064 21.1372 34.0064 21.1372 31.9064C21.1372 30.8986 21.5376 29.9321 22.2502 29.2194C22.9629 28.5068 23.9294 28.1064 24.9372 28.1064C25.9451 28.1064 26.9116 28.5068 27.6242 29.2194C28.3369 29.9321 28.7372 30.8986 28.7372 31.9064Z",
    stroke: "#0053A0",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPingprobeLogoBlue);
export default __webpack_public_path__ + "static/media/pingprobe-logo-blue.ce99f30f82264517e97ba13aa2326477.svg";
export { ForwardRef as ReactComponent };